import { useState, useEffect, useRef, useCallback } from 'react';

/**
 * Hook avanzato per rilevare l'inattività e mostrare un avviso.
 * @param {function} onIdle - Funzione da chiamare al logout finale.
 * @param {number} idleTime - Tempo totale di inattività in millisecondi.
 * @param {number} promptTime - Quanti millisecondi prima di `idleTime` mostrare l'avviso.
 */
export const useIdleTimer = (onIdle, idleMinutes = 15 , promptMinutes = 1) => {
  const idleTime = idleMinutes * 60 * 1000
  const promptTime = promptMinutes * 60 * 1000
  const [isPromptVisible, setIsPromptVisible] = useState(false);
  const idleTimeoutId = useRef(null);
  const promptTimeoutId = useRef(null);


  const startTimers = useCallback(() => {

    const promptTimeout = idleTime - promptTime;
    
    promptTimeoutId.current = setTimeout(() => {
      setIsPromptVisible(true);
    }, promptTimeout);


    idleTimeoutId.current = setTimeout(() => {
      onIdle();
    }, idleTime);
  }, [idleTime, promptTime, onIdle]);


  const clearTimers = useCallback(() => {
    clearTimeout(promptTimeoutId.current);
    clearTimeout(idleTimeoutId.current);
  }, []);

  const resetTimers = useCallback(() => {
    clearTimers();
    startTimers();
  }, [clearTimers, startTimers]);

  const stay = useCallback(() => {
    setIsPromptVisible(false);
    resetTimers();
  }, [resetTimers]);

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'click', 'scroll'];
    const handleActivity = () => resetTimers();

    events.forEach(event => window.addEventListener(event, handleActivity));
    startTimers();


    return () => {
      clearTimers();
      events.forEach(event => window.removeEventListener(event, handleActivity));
    };
  }, [resetTimers, startTimers, clearTimers]);

  return { isPromptVisible, stay };
};